import './BottomNav.css';

type TabType = 'home' | 'gacha' | 'inventory';

interface BottomNavProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
}

export function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  return (
    <nav className="bottom-nav">
      <button
        className={`bottom-nav__item ${activeTab === 'gacha' ? 'active' : ''}`}
        onClick={() => onTabChange('gacha')}
        aria-label="소환"
      >
        <img src="/gacha.png" alt="소환" className="bottom-nav__icon" />
        <span className="bottom-nav__label">소환</span>
      </button>
      <button
        className={`bottom-nav__item ${activeTab === 'home' ? 'active' : ''}`}
        onClick={() => onTabChange('home')}
        aria-label="홈"
      >
        <img src="/home.png" alt="홈" className="bottom-nav__icon" />
        <span className="bottom-nav__label">홈</span>
      </button>
      <button
        className={`bottom-nav__item ${activeTab === 'inventory' ? 'active' : ''}`}
        onClick={() => onTabChange('inventory')}
        aria-label="인벤토리"
      >
        <img src="/inventory.png" alt="인벤토리" className="bottom-nav__icon" />
        <span className="bottom-nav__label">인벤토리</span>
      </button>
    </nav>
  );
}

